module.exports = __webpack_public_path__ + "static/img/appRatingBackground.e16eb67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_design/appRatingBackground.png
// module id = 596
// module chunks = 1